export let SERVER = 'https://pj-stapor-spbo10-backend-uat.agile168.com/' // spbo api url
export let VUE_APP_MIDDLE_LAYER_API20 = 'https://pj-commis-middle-layer20-uat.agile168.com'; // 佣金中间件, 转发不同区域的佣金请求给对应的服务.
export const commissionEnable = true
export const tabDbType = ["UK", "GM","MU"]




// WEBPACK FOOTER //
// ./src/api/env.js